import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { WriterAvatar } from './writer-avatar.component'
import { UiActions } from '../../actions/ui-actions'
import { CommonModule } from '@angular/common'
import { TooltipModule } from 'ngx-bootstrap/tooltip'
import { PopoverModule } from 'ngx-bootstrap/popover'


@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    TooltipModule,
    PopoverModule.forRoot(),
  ],
  declarations: [WriterAvatar],
  exports: [WriterAvatar],
  providers: [UiActions]
})
export class WriterAvatarModule {}
